import { render } from "./XMark.vue?vue&type=template&id=21015931"
import script from "./XMark.vue?vue&type=script&lang=js"
export * from "./XMark.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__